<template>
	<div class="notRubbish">
		<form-dialog
			dialogTitle="内容"
			:dialogVisible.sync="dialog_visable"
			dialogWidth="850px"
			:appendToBody="true"
		>
			<!-- 归因 -->
			<page-card class-name="clue-attr-box" :card-list="attrList"></page-card>
			<div class="article-container">
				<div class="source-article">
					<shadow-dom :content="message.content"></shadow-dom>
				</div>
				<div class="translate-article" v-if="message.zhContent">
					<h4>译文</h4>
					<shadow-dom :content="message.zhContent"></shadow-dom>
				</div>
			</div>
			<div class="dialog-btn">
				<div>
					<el-button
						type="primary"
						size="small"
						plain
						:loading="translateLoading"
						@click="inquiryTranslate"
						v-if="inquiryData && inquiryData.translateFlag"
						>立即翻译</el-button
					>
				</div>
				<dialogfooter
					slot="footer"
					confirmText="这不是垃圾"
					@confirm="quicklyTransfer"
					@onclose="close"
					:visible.sync="dialog_visable"
				></dialogfooter>
			</div>
		</form-dialog>
		<form-dialog
			:dialogVisible.sync="visible"
			ref="formData"
			:formData="formData"
			@handleClose="convclose"
			dialogWidth="600px"
			:appendToBody="true"
		>
			<dialogtitle
				slot="title"
				title="转为非垃圾询盘"
				subtitle="此条疑似垃圾询盘将被转为正常线索，完成后您可以在线索里进行再次查看"
				:subStyle="{ display: 'block', fontSize: '12px', marginLeft: 0 }"
			></dialogtitle>
			<!-- 非垃圾 -->
			<div class="convert-form-content" style="flex-direction: column">
				<div class="convert-form-item">
					<span v-if="inquiryData && inquiryData.email" class="convert-adress">{{
						inquiryData && inquiryData.email
					}}</span>
					<span v-else class="no-convert-adress">无询盘地址</span>
					<span>
						<el-radio v-model="conver_radio" :disabled="!isShow" :label="1">添加信任地址</el-radio>
					</span>
				</div>
				<div class="convert-form-item">
					<span v-if="inquiryData" class="convert-adress">{{ getDomain }}</span>
					<span v-else class="no-convert-adress">无询盘域名</span>
					<span>
						<el-radio v-model="conver_radio" :disabled="!isShow" :label="2">添加信任域名</el-radio>
					</span>
				</div>
			</div>
			<!-- 说明文本 -->
			<div class="convert-remarks">
				<span>
					您同时可以将此询盘邮箱地址或域名加入信任名单，
					此地址或域名再次发送线索时，将会自动归为正常线索，
				</span>
				详细地址名单可进入
				<span class="font-bold">设置-系统设置-垃圾询盘过滤</span>
				中进行查看编辑
			</div>

			<dialogfooter
				slot="footer"
				@onclose="convclose"
				:visible.sync="visible"
				@confirm="submit"
			></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import pageCard from '@/components/customPageCard/pageDataCard.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import shadowDom from '@/components/shadowDom/shadowDom';
import clueSer from '@/client/services/clue/clueSer.js';
import { validRequired } from '@/common/elementValid.js';
import Name from '@/components/crm/crm-form-name.vue';
import dialogtitle from '@/components/crm/crm-dialog-title.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
	props: {
		msgVisible: {
			type: Boolean,
		},
		getDetailsData: {
			type: Object,
		},
	},
	data() {
		return {
			attrList: [],
			dialog_visable: false,
			inquiryData: {},
			translateLoading: false,
			formData: {},
			conver_radio: undefined,
			visible: false,
		};
	},
	watch: {
		msgVisible: {
			handler() {
				this.dialog_visable = this.msgVisible;
				this.getClueDetails();
			},
		},
	},
	computed: {
		...mapGetters(['chatListData', , 'allChatList']),
		message() {
			let inquiryData = this.inquiryData;
			if (inquiryData) {
				let arr = [];
				if (inquiryData.inquiryType === 2 && inquiryData.emailContentList) {
					let inquryList = inquiryData.emailContentList;
					arr = inquryList.filter(item => item.type == 1);
					if (arr.length === 0) {
						arr = inquiryData.emailContentList;
					}
					return {
						content: arr[0].content,
						zhContent: arr[0].zhContent,
					};
				} else {
					return {
						content: inquiryData.message || '',
						zhContent: inquiryData.translation || '',
					};
				}
			}
			return '';
		},
		isShow() {
			if (this.inquiryData && this.inquiryData.email) {
				return true;
			} else {
				return false;
			}
		},
		getDomain() {
			if (this.inquiryData && this.inquiryData.email) {
				return this.inquiryData.email.indexOf('@') ? this.inquiryData.email.split('@')[1] : '-';
			}
			return '-';
		},
	},
	mounted() {},
	methods: {
		...mapActions(['getEmployeeList']),
		async getEmployee() {
			let employee = await this.getEmployeeList();
			return employee;
		},
		async getClueDetails() {
			// eslint-disable-next-line no-unused-vars
			const res = await clueSer.clueDetails({
				id: this.getDetailsData.tableId,
				inquiryType: this.getDetailsData.inquiryType,
			});
			if (res) {
				this.inquiryData = res.data;
				const { inquiryData: iData } = this;
				let isFormType = res.data.inquiryType == 4 || res.data.inquiryType == 5; //4  表单询盘
				let isToday = res.data.identifiedStatus; // 状态：3正常展示
				const setValue = val => {
					if (isFormType) {
						switch (isToday) {
							case 0:
								return '识别中';
							case 1:
								return '未绑定访客ID';
							case 2:
								return '未匹配到归因信息';
							case 4:
								return '未查询到归因信息';
							// case 5:
							// 	return 'Facebook广告';
							// case 6:
							// 	return '公共主页';
						}
						return val;
					} else {
						return '-';
					}
				};
				this.attrList = [
					{
						label: '来源/媒介',
						value: setValue(iData.source),
						col: 8,
					},
					{
						label: '广告系列',
						value: setValue(iData.adSeries),
						col: 8,
					},
					{
						label: '关键词',
						value: setValue(iData.keyword),
						col: 8,
					},
				];
			} else {
				this.inquiryData = null;
				this.attrList = [];
			}
		},
		quicklyTransfer() {
			this.dialog_visable = false;
			this.visible = true;
			this.setformData();
			// this.$emit('update:msgVisible', false);
		},
		close() {
			this.dialog_visable = false;
			this.$emit('update:msgVisible', false);
		},
		// 询盘翻译
		async inquiryTranslate() {
			try {
				let { websiteType, id, inquiryType } = this.getDetailsData;
				this.translateLoading = true;
				await saleslead.inquiryTranslate({
					id,
					type: websiteType,
				});
				this.getClueDetails();
				this.translateLoading = false;
			} catch (error) {
				this.translateLoading = false;
				this.$message.warning('翻译失败，请稍后重试');
			}
		},
		setformData() {
			this.formData = {
				salesleadsId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: this.inquiryData.summaryId || '',
				},
				name: {
					label: '线索名称：',
					formType: Name,
					value: this.inquiryData.name || '',
				},
				accountIds: {
					label: '转移至：',
					value: '',
					options: this.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					multiple: false,
					placeholder: '请选择服务人员',
					rules: [validRequired('请选择服务人员', 'change')],
				},
			};
		},
		submit(cb) {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					// eslint-disable-next-line no-unused-vars
					let res = await clueSer.distributionClue({
						salesleadsId: this.inquiryData.summaryId,
						accountIds: [this.formData.accountIds.value],
						inquiryConvertDto: {
							ruleType: 0,
							mateType: this.conver_radio,
						},
					});
					if (res) {
						//对聊天列表数据进行处理，这不是垃圾不出现这条数据，聊天界面回为初始状态，侧边抽屉不显示
						//需求变更之后，操作按钮不一样，需要重新请求聊天头部接口
						let item;
						if (this.$route.name == 'allChat') {
							item = this.allChatList.find(e => {
								if (e.id == this.inquiryData.summaryId) {
									return e;
								}
							});
						} else {
							item = this.chatListData.find(e => {
								if (e.id == this.inquiryData.summaryId) {
									return e;
								}
							});
						}
						// this.chatListData.splice(flag, 1);
						// this.$store.dispatch('setChatListData', this.chatListData);
						// this.$store.dispatch('setChatNoData', false);
						this.$router.push({
							name: this.$route.name,
							query: {
								followupName: this.formData.accountIds.value,
								type: item.type,
								id: item.id,
								tableId: item.tableId,
							},
						});
						this.$emit('change', 0);
						this.visible = false;
						this.convclose();
						this.$message.success(`操作成功`);
					} else {
						this.$message.info(`操作失败`);
					}
				}
			});
		},
		convclose() {
			this.conver_radio = undefined;
		},
	},
	components: {
		pageCard,
		formDialog,
		dialogfooter,
		shadowDom,
		Name,
		dialogtitle,
	},
};
</script>
<style lang="scss">
@import '@/client/styles/mixin.scss';
.notRubbish {
	.clue-attr-box {
		padding: 7px !important;
		margin-bottom: 20px;
		background: #fafafa !important;
		border-radius: 4px !important;
	}
	.article-container {
		overflow-y: auto;
		@include scrollBar_mini(#cfcfcf);
	}
	.source-article {
		min-height: 100px;
		padding-bottom: 30px;
	}
	.translate-article {
		min-height: 100px;
		padding: 30px 0;
		border-top: 1px solid #e4e4e4;
	}
	.dialog-btn {
		display: flex;
		justify-content: space-between;
	}
	.convert-form-content {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 0 40px;

		.convert-form-item {
			padding: 10px 0;
			display: flex;
			align-items: center;
		}

		.convert-adress {
			margin-right: 40px;
			font-size: 18px;
			font-weight: 500;
			color: #333;
			width: 200px;
			text-align: left;
			display: inline-block;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.no-convert-adress {
			margin-right: 40px;
			font-size: 14px;
			font-weight: 500;
			color: #c0c4cc;
			width: 200px;
			text-align: left;
			display: inline-block;
		}
	}
	.convert-remarks {
		color: #999;
		font-size: 14px;
		font-weight: 400;
		line-height: 23px;
		margin-bottom: 20px;

		.font-bold {
			color: #333;
			font-weight: bold;
		}
	}
}
</style>
